import React from 'react';
import PropTypes from 'prop-types';

const TitleMain = props => {
  const info = props.info ? 'flex' : '';
  return (
    <section
      className={`${info} main_title_dashboard` + (props.className ? ' ' + props.className : '')}
    >
      <h1>{props.title ? props.title : ''}</h1>
      {props.info && (
        <section className={`help-component title-com`}>
          <section className="box-help">
            <i className="fas fa-question-circle" />
            <section className={`box ${props.size}`}>
              {props.info.text}

              {props.info.arr && (
                <ul className="top">
                  {props.info.arr.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          </section>
        </section>
      )}
    </section>
  );
};

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/common/titleMain.jsx